export default "__VITE_ASSET__CifnqDmU__"